import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../redux/store'

export const useTDispatch = () => useDispatch<AppDispatch>()
export const useTSelector: TypedUseSelectorHook<RootState> = useSelector
export const createThunk = <R, Arg = void>(name: string, fn: AsyncThunkPayloadCreator<R, Arg, { dispatch: AppDispatch }>) => (
    createAsyncThunk<R, Arg, { dispatch: AppDispatch }>(name, fn)
)